import { render } from "./NewsEditorEducationView.vue?vue&type=template&id=510600ff&scoped=true"
import script from "./NewsEditorEducationView.vue?vue&type=script&lang=js"
export * from "./NewsEditorEducationView.vue?vue&type=script&lang=js"

import "./NewsEditorEducationView.vue?vue&type=style&index=0&id=510600ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510600ff"]])

export default __exports__